import { render, staticRenderFns } from "./ProductPopularity.vue?vue&type=template&id=7730307b&scoped=true"
import script from "./ProductPopularity.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPopularity.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductPopularity.vue?vue&type=style&index=0&id=7730307b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7730307b",
  null
  
)

export default component.exports